/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditEndpointStatisticsRequest extends models.RequestAuditBaseRequest {
    getFixupPrototypeFunction() { return RequestAuditEndpointStatisticsRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditEndpointStatisticsRequest>): RequestAuditEndpointStatisticsRequest {
        let obj = Object.assign(new RequestAuditEndpointStatisticsRequest(), model);
        RequestAuditEndpointStatisticsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditEndpointStatisticsRequest>): RequestAuditEndpointStatisticsRequest {
        if (!model) return null;
        return RequestAuditEndpointStatisticsRequest.newInstance(<RequestAuditEndpointStatisticsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditEndpointStatisticsRequest) {
        if (!obj) return;

        models.RequestAuditEndpointStatisticsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditEndpointStatisticsRequest): boolean {
        if (models.RequestAuditBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RequestAuditEndpointStatisticsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
        if (typeof this.end_time === "string") {
            this.end_time = new Date(<string><any>this.end_time);
        }
    }

    /**
     * Collect statistics about this endpoint
     */
    endpoint: string;

    /**
     * Start time
     */
    start_time: Date;

    /**
     * End time
     */
    end_time: Date;

}
